// @ts-nocheck
import { CartUpdateEvent } from "@theme/events";

// Custom Quantity Selector Component embebido
class PivotQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.debounceTimeout = null;
    this.pending = false;
    this.quantity = 0;
    this.lastSyncedQuantity = 0;
  }

  connectedCallback() {
    this.variantId = this.getAttribute("data-variant-id");
    this.productId = this.getAttribute("data-product-id");
    this.sectionId = this.getAttribute("data-section-id");
    this.cartLine = this.getAttribute("data-cart-line");
    this.quantity = parseInt(this.getAttribute("data-initial-quantity")) || 0;
    this.lastSyncedQuantity = this.quantity;

    this.render();
  }

  setPending(pending) {
    this.pending = pending;
    this.updateDisabledState();
    // INICIO pending
    if (pending) {
      // Aquí inicia el estado pending (puedes extender para mostrar loaders)
      this.querySelector(".pvt-quantity-selector").classList.add("pending");
    } else {
      // FIN pending
      // Aquí termina el estado pending (puedes ocultar loaders)
      this.querySelector(".pvt-quantity-selector").classList.remove("pending");
    }
  }

  updateDisabledState() {
    const minus = this.querySelector(".minus");
    const plus = this.querySelector(".plus");
    const input = this.querySelector("input");
    if (minus && plus && input) {
      minus.disabled = this.pending;
      plus.disabled = this.pending;
      input.disabled = this.pending;
    }
    // INICIO disabled
    if (plus.getAttribute("pre-disabled") !== null) {
      plus.disabled = true;
    }
    if (Number(input.value) >= Number(this.dataset.maxQuantity)) {
      plus.disabled = true;
    }
  }

  render() {
    //   this.innerHTML = `
    //   <div class="pvt-quantity-selector quantity-selector">
    //     <button class="minus button quantity-minus button-unstyled" aria-label="Disminuir">-</button>
    //     <input type="number" min="0" value="${this.quantity}" />
    //     <button class="plus button quantity-plus button-unstyled" aria-label="Aumentar">+</button>
    //   </div>
    // `;
    this.querySelector(".minus").addEventListener("click", () =>
      this.changeQuantity(-1)
    );
    this.querySelector(".plus").addEventListener("click", () =>
      this.changeQuantity(1)
    );
    this.querySelector("input").addEventListener("input", (e) =>
      this.inputQuantity(e)
    );
    this.querySelector("input").addEventListener("blur", () =>
      this.syncQuantity()
    );
    this.updateDisabledState();
  }

  changeQuantity(delta) {
    let newQty = this.quantity + delta;
    if (newQty < 0) newQty = 0;
    if (newQty > Number(this.dataset.maxQuantity))
      newQty = Number(this.dataset.maxQuantity);
    this.setQuantity(newQty);
  }

  inputQuantity(e) {
    let val = parseInt(e.target.value);
    if (isNaN(val) || val < 0) val = 0;
    this.setQuantity(val);
  }

  setQuantity(qty) {
    if (qty === this.quantity) return;
    this.quantity = qty;
    this.querySelector("input").value = qty;
    this.debounceSync();
  }

  debounceSync() {
    if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => this.syncQuantity(), 600);
  }

  syncQuantity() {
    if (this.quantity === this.lastSyncedQuantity) {
      this.setPending(false);
      return;
    }
    this.setPending(true);
    // Simulación de llamada a API para actualizar carrito
    this.updateCart(this.variantId, this.quantity)
      .then((response) => {
        this.lastSyncedQuantity = this.quantity;
        // Ya se actualizó el carrito
        // Aquí puedes disparar eventos o hooks para otras extensiones
        // FIN actualización de carrito
        document.dispatchEvent(
          new CartUpdateEvent({}, this.dataset.sectionId, {
            sections: response.sections,
            didError: true,
            variantId: this.dataset.variantId,
            itemCount: response.itemCount,
            source: "pivot-quantity-selector",
            productId: this.dataset.productId,
          })
        );
      })
      .finally(() => {
        this.setPending(false);
      });
  }

  async updateCart(variantId, quantity) {
    // Shopify: si quantity == 0, elimina; si no hay línea, agrega; si hay línea, actualiza
    const line = this.cartLine;
    console.log("line", { line, quantity });
    if (!line) {
      // Agregar al carrito
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: {
            _venderen: this.dataset.venderen === 'true' ? '2' : null,
          },
        }),
      }).then((r) => {
        this.cartLine = true;
        return r.json();
      });
    }
    // Actualizar cantidad existente
    return fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: this.variantId,
        quantity: quantity,
      }),
    }).then((r) => {
      if (quantity === 0) this.cartLine = false;
      else this.cartLine = true;
      return r.json();
    });
  }
}
customElements.define("pivot-quantity-selector", PivotQuantitySelector);
